import React, { useState, useContext, useEffect } from 'react';
import './wallet.css';
import { MainTitle } from '../../../../components/mini-components/mini-components.jsx';
import UserContext from '../../../../context/user_context';
import { db } from '../../../../config/firebase_config.js';
import { ref, onValue } from 'firebase/database';
import UserModel from '../../../../models/user_model';
import CartContext from "../../../../context/cart_context.js";
import toast from "react-hot-toast";


const Wallet = () => {
  const [isChecked, setIsChecked] = useState(false);
  const { userInfo, setUserInfo } = useContext(UserContext);
  const { payFromWallet ,setPayFromWallet} = useContext(CartContext);

  useEffect(() => {
    var unsubscribe ;
    const updateUserInfo = (snapshot) => {
      const data = snapshot.val();
      console.log(data);
      if (data != null) {
      const userData = UserModel.fromJson(data);
      if (userData.balance !== userInfo.balance) {
        setUserInfo(userData);
        localStorage.setItem('user', JSON.stringify(userData.toJson()));
      }
    }
    };

    setIsChecked(payFromWallet);
    
    if(userInfo != null){
      const databaseRef = ref(db, `Users/${userInfo.phoneNo}`);
      unsubscribe = onValue(databaseRef, updateUserInfo);
    }

    return () => {
      if(userInfo != null){
        unsubscribe();
      }
    };
  }, [userInfo, setUserInfo]);

  const handleCheckboxChange = (event) => {
    setIsChecked(event.target.checked);
    setPayFromWallet(event.target.checked);
  };

  return (
    userInfo != null && (
      <div className="checkout-item-container">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
          <MainTitle title={'Wallet Balance'} />
          <button 
            onClick={() => toast("Add Money feature coming soon!", { icon: "💰" })}
            style={{ 
              background: 'transparent', 
              border: '1px solid #6366f1', 
              color: '#6366f1', 
              padding: '6px 12px', 
              borderRadius: '8px', 
              fontSize: '12px', 
              cursor: 'pointer', 
              fontWeight: 'bold',
              transition: 'all 0.2s'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = 'rgba(99, 102, 241, 0.1)' }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = 'transparent' }}
          >
            + Add Money
          </button>
        </div>
        <div className="wallet-container">
          <input
            type="checkbox"
            checked={isChecked}
            id="wallet-box"
            onChange={handleCheckboxChange}
            className="checkbox-input"
          />
          <label htmlFor="wallet-box">use Wallet Balance</label>
          <span className="wallet-balance">{'\u{20B9}\t'}{userInfo.balance}</span>
        </div>
      </div>
    )
  );
};

export default Wallet;
